import { EventEmitter, Injectable, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { DeviceSubscriptionOfferExt } from 'src/app/generated/CrossPoint.License.Server';
import { addLicenseToShoppingBasketAction, clearShoppingBasketAction, getLicensesLocalStorageAction, removeLicenseFromShoppingBasketAction } from 'src/app/store/actions/licenses.actions';
import { selectShoppingBasket } from 'src/app/store/selectors/licenses.selectors';
import { IRemoteXPACPortalState } from 'src/app/utils/interfaces/store.interfaces';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class ShoppingBasketService {
  private shoppingBasket: DeviceSubscriptionOfferExt[] = [];
  @Output() public onLicensesChangedCallback = new EventEmitter<any>();

  constructor(private store: Store<IRemoteXPACPortalState>) {
    this.initialize();    
  }

  public isLicenseInShoppingBasket(license: DeviceSubscriptionOfferExt): boolean {
    return this.shoppingBasket.some((item: DeviceSubscriptionOfferExt) => item.serial === license.serial);
  }

  public add(item: DeviceSubscriptionOfferExt): void {

    if(item.months === 0)
    {
      // add DeviceSubscriptionOfferExt with baseprice 0 to cancel auto subscription
      this.store.dispatch(addLicenseToShoppingBasketAction({
        data: {
          serial: item.serial,
          currency: item.currency,
          basePrice: 0,
          reconnectionFee: 0,
          months: 0,
          store: item.store,
          retailerCompany: item.retailerCompany,
          lastOnlineUtc: item.lastOnlineUtc,
          installationDateUtc: item.installationDateUtc,
          remoteMaintenanceStartsUtc: item.remoteMaintenanceStartsUtc,
          remoteMaintenanceEndsUtc: item.remoteMaintenanceEndsUtc,
          remoteMaintenanceLastInvoiceUtc: item.remoteMaintenanceLastInvoiceUtc,
          cancelDateUtc: item.cancelDateUtc
        }
      }));
    }
    else{
      this.store.dispatch(addLicenseToShoppingBasketAction({ data: item }));    
    }    
  }

  public remove(item: DeviceSubscriptionOfferExt): void {
    this.store.dispatch(removeLicenseFromShoppingBasketAction({ data: item }));
    this.onLicensesChangedCallback.emit();
  }

  public clear(): void {
    this.store.dispatch(clearShoppingBasketAction());
    this.onLicensesChangedCallback.emit();
  }

  private initialize(): void {
    this.store.select(selectShoppingBasket)
      .pipe(
        filter<DeviceSubscriptionOfferExt[]>(Boolean),
        untilDestroyed(this)
      )
      .subscribe((shoppingBasket: DeviceSubscriptionOfferExt[]) => {
        this.shoppingBasket = shoppingBasket;
        this.onLicensesChangedCallback.emit();
      });

    this.store.dispatch(getLicensesLocalStorageAction());
  }
}
